var __jsx = React.createElement;
import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { Container, Typography, MenuItem, Box } from '@mui/material';
import LocaleSelect from '../../../molecules/LocaleSelect';
import { useTranslation } from '../../../../config/i18n';
import { currencies } from '../../../../constants';
import { SubFooterContainer, StyledTextField, CurrencyBox, LanguagesBox } from './style';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function SubFooter() {
  var _useTranslation = useTranslation(['footer']),
    t = _useTranslation.t;
  var _useState = useState('eur'),
    currencyValue = _useState[0],
    setCurrencyValue = _useState[1];

  // const currenciesList = useMemo(
  //   () => currencies.map((currency) => ({ label: currency.toUpperCase(), value: currency })),
  //   currencies
  // );

  return /*#__PURE__*/_jsx(SubFooterContainer, {
    children: /*#__PURE__*/_jsx(Container, {
      maxWidth: "xl",
      children: /*#__PURE__*/_jsxs(Grid, {
        container: true,
        className: "mainContainer",
        children: [/*#__PURE__*/_jsx(Grid, {
          item: true,
          lg: 6,
          sm: 6,
          md: 6,
          xs: 12,
          className: "copyright",
          children: /*#__PURE__*/_jsxs(Typography, {
            variant: "body2",
            children: ["\xA9 ", new Date().getFullYear(), " ", t('copyright')]
          })
        }), /*#__PURE__*/_jsx(Grid, {
          item: true,
          lg: 3,
          sm: 6,
          md: 4,
          xs: 12,
          width: "100%",
          children: /*#__PURE__*/_jsxs(Grid, {
            container: true,
            alignItems: "center",
            justifyContent: "flex-end",
            className: "currency",
            children: [/*#__PURE__*/_jsx(CurrencyBox, {
              item: true,
              lg: 5,
              sm: 4,
              xs: 3,
              children: /*#__PURE__*/_jsx(StyledTextField, {
                id: "standard-select-currency",
                select: true
                // label={t('payment:currency')}
                ,
                value: currencyValue
                // disabled
                ,
                onChange: function onChange(e) {
                  return setCurrencyValue(e.target.value);
                }
                // variant="outlined"

                // disabled={fee.is_used}
                //   fullWidth={fullWidth}
                ,
                children: currencies.map(function (option) {
                  return /*#__PURE__*/_jsx(MenuItem, {
                    value: option,
                    children: /*#__PURE__*/_jsx(Typography, {
                      variant: "caption",
                      children: option.toLocaleUpperCase()
                    })
                  }, option);
                })
              })
            }), /*#__PURE__*/_jsx(LanguagesBox, {
              item: true,
              lg: 5,
              md: 6,
              xs: 3,
              children: /*#__PURE__*/_jsx(LocaleSelect, {
                id: "footer-language-menu",
                className: "locales"
              })
            })]
          })
        })]
      })
    })
  });
}